import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  addProduct(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const ts = new Date().getTime()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, ts)
    this.containerTarget.insertAdjacentHTML("beforeend", content)

    // Find the newly inserted row (last row)
    const row = this.containerTarget.lastElementChild
    if (!row) return

    // Fill in product data
    const skuInput = row.querySelector("input[name*='[sku]']")
    const descInput = row.querySelector("input[name*='[description]']")
    const priceInput = row.querySelector("input[name*='[unit_price]']")
    const productIdInput = row.querySelector("input[name*='[product_id]']")

    if (skuInput) skuInput.value = btn.dataset.productSku || ""
    if (descInput) descInput.value = btn.dataset.productName || ""
    if (priceInput) priceInput.value = btn.dataset.productPrice || ""
    if (productIdInput) productIdInput.value = btn.dataset.productId || ""
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-line-item-row]")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
